// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "appointment".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { appointmentColorValues, appointmentSourceValues, appointmentStatusValues } from '@borradh-workspace/labels';
/** Response atom for the "appointment" table (1:1 with a DB row, on the wire). */
export const appointmentAtomSchema = z.object({
    id: z.string(),
    title: z.string(),
    startDate: z.string().datetime(),
    endDate: z.string().datetime(),
    description: z.string().nullable(),
    color: z.enum(appointmentColorValues),
    status: z.enum(appointmentStatusValues),
    source: z.enum(appointmentSourceValues),
    leadId: z.string(),
    assignedToId: z.string().nullable(),
    organizationId: z.string(),
    locationId: z.string().nullable(),
    practitionerId: z.string().nullable(),
    serviceId: z.string().nullable(),
    bookingGroupId: z.string().nullable(),
    calendarAccountId: z.string().nullable(),
    externalCalendarEventId: z.string().nullable(),
    externalCalendarIcalUid: z.string().nullable(),
    virtualMeetingUrl: z.string().nullable(),
    externalCalendarEtag: z.string().nullable(),
    depositRequired: z.boolean(),
    holdExpiresAt: z.string().datetime().nullable(),
    allowDoubleBooking: z.boolean(),
    reminderSentAt24h: z.string().datetime().nullable(),
    reminderSentAt1h: z.string().datetime().nullable(),
    smsReminderSentAt24h: z.string().datetime().nullable(),
    smsReminderSentAt1h: z.string().datetime().nullable(),
    reviewRequestedAt: z.string().datetime().nullable(),
    reviewSentAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    deletedAt: z.string().datetime().nullable(),
});
//# sourceMappingURL=appointment.js.map